import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/responsive-tables.css';
import App from './App';
import 'jquery/dist/jquery.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { CURRENT_AUTH_VERSION } from './constants.js';

// 🔐 Check auth version BEFORE React loads
const storedVersion = localStorage.getItem("techtop_auth_version");

if (!storedVersion || storedVersion !== CURRENT_AUTH_VERSION) {
    console.log("Auth version mismatch — resetting session");
    localStorage.clear();
    localStorage.setItem("techtop_auth_version", CURRENT_AUTH_VERSION);
}

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root')
);

serviceWorker.unregister();